// extracted by mini-css-extract-plugin
export default {"banner":"banner-ijEx3L"};